import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=fc6ed87e&scoped=true"
import script from "./_name.vue?vue&type=script&lang=js"
export * from "./_name.vue?vue&type=script&lang=js"
import style0 from "./_name.vue?vue&type=style&index=0&id=fc6ed87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6ed87e",
  null
  
)

export default component.exports